import {
  createErrorType,
  createLoadingType,
  createSubmitType,
  createSuccessType,
  createUpdateType,
} from '../actionHelpers';

// create person Name
const CREATE_PERSON_NAME_SCOPE = 'CREATE_PERSON_NAME';
export const CREATE_PERSON_NAME = createSubmitType(CREATE_PERSON_NAME_SCOPE);
export const CREATE_PERSON_NAME_SUCCESS = createSuccessType(
  CREATE_PERSON_NAME_SCOPE,
);
export const CREATE_PERSON_NAME_ERROR = createErrorType(
  CREATE_PERSON_NAME_SCOPE,
);
export const CREATE_PERSON_NAME_LOADING = createLoadingType(
  CREATE_PERSON_NAME_SCOPE,
);

// update person Name
const UPDATE_PERSON_NAME_SCOPE = 'UPDATE_PERSON_NAME';
export const UPDATE_PERSON_NAME = createUpdateType(UPDATE_PERSON_NAME_SCOPE);
export const UPDATE_PERSON_NAME_SUCCESS = createSuccessType(
  UPDATE_PERSON_NAME_SCOPE,
);
export const UPDATE_PERSON_NAME_ERROR = createErrorType(
  UPDATE_PERSON_NAME_SCOPE,
);
export const UPDATE_PERSON_NAME_LOADING = createLoadingType(
  UPDATE_PERSON_NAME_SCOPE,
);

// create person SSN
const CREATE_PERSON_SSN_SCOPE = 'CREATE_PERSON_SSN';
export const CREATE_PERSON_SSN = createSubmitType(CREATE_PERSON_SSN_SCOPE);
export const CREATE_PERSON_SSN_SUCCESS = createSuccessType(
  CREATE_PERSON_SSN_SCOPE,
);
export const CREATE_PERSON_SSN_ERROR = createErrorType(CREATE_PERSON_SSN_SCOPE);
export const CREATE_PERSON_SSN_LOADING = createLoadingType(
  CREATE_PERSON_SSN_SCOPE,
);

// update person SSN
const UPDATE_PERSON_SSN_SCOPE = 'UPDATE_PERSON_SSN';
export const UPDATE_PERSON_SSN = createUpdateType(UPDATE_PERSON_SSN_SCOPE);
export const UPDATE_PERSON_SSN_SUCCESS = createSuccessType(
  UPDATE_PERSON_SSN_SCOPE,
);
export const UPDATE_PERSON_SSN_ERROR = createErrorType(UPDATE_PERSON_SSN_SCOPE);
export const UPDATE_PERSON_SSN_LOADING = createLoadingType(
  UPDATE_PERSON_SSN_SCOPE,
);

// create person Address
const CREATE_PERSON_ADDRESS_SCOPE = 'CREATE_PERSON_ADDRESS';
export const CREATE_PERSON_ADDRESS = createSubmitType(
  CREATE_PERSON_ADDRESS_SCOPE,
);
export const CREATE_PERSON_ADDRESS_SUCCESS = createSuccessType(
  CREATE_PERSON_ADDRESS_SCOPE,
);
export const CREATE_PERSON_ADDRESS_ERROR = createErrorType(
  CREATE_PERSON_ADDRESS_SCOPE,
);
export const CREATE_PERSON_ADDRESS_LOADING = createLoadingType(
  CREATE_PERSON_ADDRESS_SCOPE,
);

// update person Address
const UPDATE_PERSON_ADDRESS_SCOPE = 'UPDATE_PERSON_ADDRESS';
export const UPDATE_PERSON_ADDRESS = createUpdateType(
  UPDATE_PERSON_ADDRESS_SCOPE,
);
export const UPDATE_PERSON_ADDRESS_SUCCESS = createSuccessType(
  UPDATE_PERSON_ADDRESS_SCOPE,
);
export const UPDATE_PERSON_ADDRESS_ERROR = createErrorType(
  UPDATE_PERSON_ADDRESS_SCOPE,
);
export const UPDATE_PERSON_ADDRESS_LOADING = createLoadingType(
  UPDATE_PERSON_ADDRESS_SCOPE,
);

// create person Birthday
const CREATE_PERSON_BIRTHDAY_SCOPE = 'CREATE_PERSON_BIRTHDAY';
export const CREATE_PERSON_BIRTHDAY = createSubmitType(
  CREATE_PERSON_BIRTHDAY_SCOPE,
);
export const CREATE_PERSON_BIRTHDAY_SUCCESS = createSuccessType(
  CREATE_PERSON_BIRTHDAY_SCOPE,
);
export const CREATE_PERSON_BIRTHDAY_ERROR = createErrorType(
  CREATE_PERSON_BIRTHDAY_SCOPE,
);
export const CREATE_PERSON_BIRTHDAY_LOADING = createLoadingType(
  CREATE_PERSON_BIRTHDAY_SCOPE,
);

// update person Birthday
const UPDATE_PERSON_BIRTHDAY_SCOPE = 'UPDATE_PERSON_BIRTHDAY';
export const UPDATE_PERSON_BIRTHDAY = createUpdateType(
  UPDATE_PERSON_BIRTHDAY_SCOPE,
);
export const UPDATE_PERSON_BIRTHDAY_SUCCESS = createSuccessType(
  UPDATE_PERSON_BIRTHDAY_SCOPE,
);
export const UPDATE_PERSON_BIRTHDAY_ERROR = createErrorType(
  UPDATE_PERSON_BIRTHDAY_SCOPE,
);
export const UPDATE_PERSON_BIRTHDAY_LOADING = createLoadingType(
  UPDATE_PERSON_BIRTHDAY_SCOPE,
);

// create person Country
const CREATE_PERSON_COUNTRY_SCOPE = 'CREATE_PERSON_COUNTRY';
export const CREATE_PERSON_COUNTRY = createSubmitType(
  CREATE_PERSON_COUNTRY_SCOPE,
);
export const CREATE_PERSON_COUNTRY_SUCCESS = createSuccessType(
  CREATE_PERSON_COUNTRY_SCOPE,
);
export const CREATE_PERSON_COUNTRY_ERROR = createErrorType(
  CREATE_PERSON_COUNTRY_SCOPE,
);
export const CREATE_PERSON_COUNTRY_LOADING = createLoadingType(
  CREATE_PERSON_COUNTRY_SCOPE,
);

// update person Country
const UPDATE_PERSON_COUNTRY_SCOPE = 'UPDATE_PERSON_COUNTRY';
export const UPDATE_PERSON_COUNTRY = createUpdateType(
  UPDATE_PERSON_COUNTRY_SCOPE,
);
export const UPDATE_PERSON_COUNTRY_SUCCESS = createSuccessType(
  UPDATE_PERSON_COUNTRY_SCOPE,
);
export const UPDATE_PERSON_COUNTRY_ERROR = createErrorType(
  UPDATE_PERSON_COUNTRY_SCOPE,
);
export const UPDATE_PERSON_COUNTRY_LOADING = createLoadingType(
  UPDATE_PERSON_COUNTRY_SCOPE,
);

// create person Backup with Holdings
const CREATE_PERSON_BACKUP_WITH_HOLDINGS_SCOPE =
  'CREATE_PERSON_BACKUP_WITH_HOLDINGS';
export const CREATE_PERSON_BACKUP_WITH_HOLDINGS = createSubmitType(
  CREATE_PERSON_BACKUP_WITH_HOLDINGS_SCOPE,
);
export const CREATE_PERSON_BACKUP_WITH_HOLDINGS_SUCCESS = createSuccessType(
  CREATE_PERSON_BACKUP_WITH_HOLDINGS_SCOPE,
);
export const CREATE_PERSON_BACKUP_WITH_HOLDINGS_ERROR = createErrorType(
  CREATE_PERSON_BACKUP_WITH_HOLDINGS_SCOPE,
);
export const CREATE_PERSON_BACKUP_WITH_HOLDINGS_LOADING = createLoadingType(
  CREATE_PERSON_BACKUP_WITH_HOLDINGS_SCOPE,
);

// update person Backup wit Holdings
const UPDATE_PERSON_BACKUP_WITH_HOLDINGS_SCOPE =
  'UPDATE_PERSON_BACKUP_WITH_HOLDINGS';
export const UPDATE_PERSON_BACKUP_WITH_HOLDINGS = createUpdateType(
  UPDATE_PERSON_BACKUP_WITH_HOLDINGS_SCOPE,
);
export const UPDATE_PERSON_BACKUP_WITH_HOLDINGS_SUCCESS = createSuccessType(
  UPDATE_PERSON_BACKUP_WITH_HOLDINGS_SCOPE,
);
export const UPDATE_PERSON_BACKUP_WITH_HOLDINGS_ERROR = createErrorType(
  UPDATE_PERSON_BACKUP_WITH_HOLDINGS_SCOPE,
);
export const UPDATE_PERSON_BACKUP_WITH_HOLDINGS_LOADING = createLoadingType(
  UPDATE_PERSON_BACKUP_WITH_HOLDINGS_SCOPE,
);

// create person Phone
const CREATE_PERSON_PHONE_SCOPE = 'CREATE_PERSON_PHONE';
export const CREATE_PERSON_PHONE = createSubmitType(CREATE_PERSON_PHONE_SCOPE);
export const CREATE_PERSON_PHONE_SUCCESS = createSuccessType(
  CREATE_PERSON_PHONE_SCOPE,
);
export const CREATE_PERSON_PHONE_ERROR = createErrorType(
  CREATE_PERSON_PHONE_SCOPE,
);
export const CREATE_PERSON_PHONE_LOADING = createLoadingType(
  CREATE_PERSON_PHONE_SCOPE,
);

// update person Phone
const UPDATE_PERSON_PHONE_SCOPE = 'UPDATE_PERSON_PHONE';
export const UPDATE_PERSON_PHONE = createUpdateType(UPDATE_PERSON_PHONE_SCOPE);
export const UPDATE_PERSON_PHONE_SUCCESS = createSuccessType(
  UPDATE_PERSON_PHONE_SCOPE,
);
export const UPDATE_PERSON_PHONE_ERROR = createErrorType(
  UPDATE_PERSON_PHONE_SCOPE,
);
export const UPDATE_PERSON_PHONE_LOADING = createLoadingType(
  UPDATE_PERSON_PHONE_SCOPE,
);

// create legal entity name
const CREATE_LEGAL_ENTITY_NAME_SCOPE = 'CREATE_LEGAL_ENTITY_NAME';
export const CREATE_LEGAL_ENTITY_NAME = createSubmitType(
  CREATE_LEGAL_ENTITY_NAME_SCOPE,
);
export const CREATE_LEGAL_ENTITY_NAME_SUCCESS = createSuccessType(
  CREATE_LEGAL_ENTITY_NAME_SCOPE,
);
export const CREATE_LEGAL_ENTITY_NAME_ERROR = createErrorType(
  CREATE_LEGAL_ENTITY_NAME_SCOPE,
);
export const CREATE_LEGAL_ENTITY_NAME_LOADING = createLoadingType(
  CREATE_LEGAL_ENTITY_NAME_SCOPE,
);

// Update legal entity Name
const UPDATE_LEGAL_ENTITY_NAME_SCOPE = 'UPDATE_LEGAL_ENTITY_NAME';
export const UPDATE_LEGAL_ENTITY_NAME = createUpdateType(
  UPDATE_LEGAL_ENTITY_NAME_SCOPE,
);
export const UPDATE_LEGAL_ENTITY_NAME_SUCCESS = createSuccessType(
  UPDATE_LEGAL_ENTITY_NAME_SCOPE,
);
export const UPDATE_LEGAL_ENTITY_NAME_ERROR = createErrorType(
  UPDATE_LEGAL_ENTITY_NAME_SCOPE,
);
export const UPDATE_LEGAL_ENTITY_NAME_LOADING = createLoadingType(
  UPDATE_LEGAL_ENTITY_NAME_SCOPE,
);

const CREATE_LEGAL_ENTITY_EIN_SCOPE = 'CREATE_LEGAL_ENTITY_EIN';
export const CREATE_LEGAL_ENTITY_EIN = createSubmitType(
  CREATE_LEGAL_ENTITY_EIN_SCOPE,
);
export const CREATE_LEGAL_ENTITY_EIN_SUCCESS = createSuccessType(
  CREATE_LEGAL_ENTITY_EIN_SCOPE,
);
export const CREATE_LEGAL_ENTITY_EIN_ERROR = createErrorType(
  CREATE_LEGAL_ENTITY_EIN_SCOPE,
);
export const CREATE_LEGAL_ENTITY_EIN_LOADING = createLoadingType(
  CREATE_LEGAL_ENTITY_EIN_SCOPE,
);

const UPDATE_LEGAL_ENTITY_EIN_SCOPE = 'UPDATE_LEGAL_ENTITY_EIN';
export const UPDATE_LEGAL_ENTITY_EIN = createUpdateType(
  UPDATE_LEGAL_ENTITY_EIN_SCOPE,
);
export const UPDATE_LEGAL_ENTITY_EIN_SUCCESS = createSuccessType(
  UPDATE_LEGAL_ENTITY_EIN_SCOPE,
);
export const UPDATE_LEGAL_ENTITY_EIN_ERROR = createErrorType(
  UPDATE_LEGAL_ENTITY_EIN_SCOPE,
);
export const UPDATE_LEGAL_ENTITY_EIN_LOADING = createLoadingType(
  UPDATE_LEGAL_ENTITY_EIN_SCOPE,
);

const CREATE_LEGAL_ENTITY_ADDRESS_SCOPE = 'CREATE_LEGAL_ENTITY_ADDRESS';
export const CREATE_LEGAL_ENTITY_ADDRESS = createSubmitType(
  CREATE_LEGAL_ENTITY_ADDRESS_SCOPE,
);
export const CREATE_LEGAL_ENTITY_ADDRESS_SUCCESS = createSuccessType(
  CREATE_LEGAL_ENTITY_ADDRESS_SCOPE,
);
export const CREATE_LEGAL_ENTITY_ADDRESS_ERROR = createErrorType(
  CREATE_LEGAL_ENTITY_ADDRESS_SCOPE,
);
export const CREATE_LEGAL_ENTITY_ADDRESS_LOADING = createLoadingType(
  CREATE_LEGAL_ENTITY_ADDRESS_SCOPE,
);

const UPDATE_LEGAL_ENTITY_ADDRESS_SCOPE = 'UPDATE_LEGAL_ENTITY_ADDRESS';
export const UPDATE_LEGAL_ENTITY_ADDRESS = createUpdateType(
  UPDATE_LEGAL_ENTITY_ADDRESS_SCOPE,
);
export const UPDATE_LEGAL_ENTITY_ADDRESS_SUCCESS = createSuccessType(
  UPDATE_LEGAL_ENTITY_ADDRESS_SCOPE,
);
export const UPDATE_LEGAL_ENTITY_ADDRESS_ERROR = createErrorType(
  UPDATE_LEGAL_ENTITY_ADDRESS_SCOPE,
);
export const UPDATE_LEGAL_ENTITY_ADDRESS_LOADING = createLoadingType(
  UPDATE_LEGAL_ENTITY_ADDRESS_SCOPE,
);

const CREATE_PERSON_MARTIAL_STATUS_SCOPE = 'CREATE_PERSON_MARTIAL_STATUS';
export const CREATE_PERSON_MARTIAL_STATUS = createSubmitType(
  CREATE_PERSON_MARTIAL_STATUS_SCOPE,
);
export const CREATE_PERSON_MARTIAL_STATUS_SUCCESS = createSuccessType(
  CREATE_PERSON_MARTIAL_STATUS_SCOPE,
);
export const CREATE_PERSON_MARTIAL_STATUS_ERROR = createErrorType(
  CREATE_PERSON_MARTIAL_STATUS_SCOPE,
);
export const CREATE_PERSON_MARTIAL_STATUS_LOADING = createLoadingType(
  CREATE_PERSON_MARTIAL_STATUS_SCOPE,
);

const UPDATE_PERSON_MARTIAL_STATUS_SCOPE = 'UPDATE_PERSON_MARTIAL_STATUS';
export const UPDATE_PERSON_MARTIAL_STATUS = createUpdateType(
  UPDATE_PERSON_MARTIAL_STATUS_SCOPE,
);
export const UPDATE_PERSON_MARTIAL_STATUS_SUCCESS = createSuccessType(
  UPDATE_PERSON_MARTIAL_STATUS_SCOPE,
);
export const UPDATE_PERSON_MARTIAL_STATUS_ERROR = createErrorType(
  UPDATE_PERSON_MARTIAL_STATUS_SCOPE,
);
export const UPDATE_PERSON_MARTIAL_STATUS_LOADING = createLoadingType(
  UPDATE_PERSON_MARTIAL_STATUS_SCOPE,
);
